/**
 * Meta Pixel event helpers.
 *
 * Base pixel + first PageView is fired from /public/index.html.
 * This module dispatches:
 *   - PageView   on SPA route change (handled by <PixelRouteTracker />)
 *   - Lead       on successful email subscribe (footer + /sleep funnel)
 *   - ViewContent on /sleep funnel entry
 *   - Contact    on WhatsApp CTA clicks (delegated globally)
 *   - CompleteRegistration on Insight Timer follow confirmation
 *
 * All calls are defensive — if window.fbq is not loaded (ad blocker /
 * offline) the calls silently no-op.
 */

const PIXEL_ID = "901735698992297";

const fbq = (...args) => {
    if (typeof window === "undefined") return;
    if (typeof window.fbq !== "function") return;
    try {
        window.fbq(...args);
    } catch (e) {
        // swallow — never break the UX over analytics
    }
};

export const PIXEL_LOADED = () =>
    typeof window !== "undefined" && typeof window.fbq === "function";

export const trackPageView = () => {
    fbq("track", "PageView");
};

export const trackLead = (params = {}) => {
    fbq("track", "Lead", {
        content_name: params.content_name || "Sleep Track",
        content_category: params.content_category || "email_capture",
        ...params,
    });
};

export const trackViewContent = (params = {}) => {
    fbq("track", "ViewContent", {
        content_name: params.content_name || "Sleep Funnel",
        content_category: params.content_category || "landing_page",
        ...params,
    });
};

export const trackContact = (params = {}) => {
    fbq("track", "Contact", {
        content_name: params.content_name || "WhatsApp",
        ...params,
    });
};

export const trackCompleteRegistration = (params = {}) => {
    fbq("track", "CompleteRegistration", {
        content_name: params.content_name || "Insight Timer Follow",
        ...params,
    });
};

export const trackCustom = (event, params = {}) => {
    fbq("trackCustom", event, params);
};

export { PIXEL_ID };
